import { render } from "./PedidoListagem.vue?vue&type=template&id=d17bcbc0&scoped=true&ts=true"
import script from "./PedidoListagem.vue?vue&type=script&lang=ts"
export * from "./PedidoListagem.vue?vue&type=script&lang=ts"

import "./PedidoListagem.vue?vue&type=style&index=0&id=d17bcbc0&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d17bcbc0"]])

export default __exports__